import React, { ComponentType, useCallback, useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { DisciplineRouteType } from '@om-fe/core/components/discipline-anchor/discipline-route.utils';
import { CustomContentType } from '@om-fe/core/components/custom-content/custom-content.constants';
import { AppState } from '@om-fe/core/core/types';
import { VirtualSportsLoadLazy } from '@om-fe/core/core/widgets/omfe-widgets';
import getConfig, { VirtualSportsConfig } from '@om-fe/core/utils/config';
import { DisciplinesType } from '@om-fe/models';
import { Breadcrumbs } from '../components/breadcrumbs/breadcrumbs';
import { useI18NContext } from '@om-fe/core/core/i18n/useI18ncontext';

interface VirtualSportsPageStoreProps {
    readonly isLarge: boolean;
}

const VirtualSportsPageComponent = ({isLarge}: VirtualSportsPageStoreProps) => {
    const virtualSportsConfig: VirtualSportsConfig | undefined = getConfig().virtualSportsConfig;
    const { gettext } = useI18NContext();
    const virtualSportsRef = useRef<HTMLDivElement>(null);
    const resizeObserver = useRef<ResizeObserver | null>(null);
    const [iframeWidth, setIframeWidth] = useState<number>(window.innerWidth);

    const checkScrollbarChange = useCallback(() => {
        if (virtualSportsRef.current) {
            if (resizeObserver.current) {
                resizeObserver.current.disconnect();
            }

            let timeoutId: ReturnType<typeof setTimeout>;
            resizeObserver.current = new ResizeObserver(() => {
                const checkRenderSize = (): void => {
                    if (virtualSportsRef.current) {
                        if (virtualSportsRef.current?.clientWidth) {
                            setIframeWidth(virtualSportsRef.current?.clientWidth)
                        }
                    }
                };

                if (timeoutId) {
                    clearTimeout(timeoutId);
                }
                timeoutId = setTimeout(checkRenderSize, 0 );
            });

            resizeObserver.current.observe(virtualSportsRef.current);
        }
    }, []);
    
    useEffect(() => {
        checkScrollbarChange();
    }, [checkScrollbarChange]);

    return (
        <div ref={virtualSportsRef}>
            <Breadcrumbs
                disciplineId={DisciplinesType.VirtualSports}
                locationId={'0'}
                isLarge={isLarge}
                routeType={DisciplineRouteType.Location}
            />
            {!!virtualSportsConfig
                ?
                    <VirtualSportsLoadLazy
                        bettingRuleUrl={virtualSportsConfig?.bettingRuleUrl}
                        statisticsUrl={virtualSportsConfig?.statisticsUrl}
                        statisticsVirtualUrl={virtualSportsConfig?.statisticsVirtualUrl}
                        contentUrl={virtualSportsConfig?.contentUrl}
                        contentType={CustomContentType.FAQ}
                        clientId={virtualSportsConfig?.clientId}
                        enabledCustomWidth={true}
                        customWidth={iframeWidth}
                />
                : gettext('Virtual Sports Not Available')
            }
        </div>
    )
}

const VirtualSportsPage: ComponentType<VirtualSportsPageStoreProps> = connect<VirtualSportsPageStoreProps, AppState>(
    (state: AppState): VirtualSportsPageStoreProps => {
        return {
            isLarge: (state.breakpoints.large || state.breakpoints.xl),
        }
    }
)(VirtualSportsPageComponent);

export default VirtualSportsPage;
